<template>
  <div id="app">
    <!-- <Login></Login> -->

    <router-view />
  </div>
</template>
<script>
import Login from "./views/login";
import Layout from "./views/layout";
export default {
  name: "App",
  components: {
    Login,
    Layout,
  },
};
</script>

<style lang="less" scoped></style>
